<template>
    <loading
        :active="loadingStatus"
        :is-full-page="isFullPage"
        :opacity="0.7"
        :background-color="'#ffffff'"
        class="custom-loader-overlay d-none">
        <!-- Custom loader content with logo and circular spinner -->
        <div class="loader-content d-none">
            <div class="spinner-wrapper">
                <!-- Rotating outer ring -->
                <div class="rotating-border"></div>
                <!-- Logo container -->
                <div class="logo-container">
                    <img :src="$defaultLoadingImageSrc" alt="Logo" class="loader-logo" />
                </div>
            </div>
        </div>
    </loading>
</template>

<script>

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  name: 'Loader',
  data () {
    return {
      isFullPage: true
    }
  },
  components: {
    Loading
  },
  computed: {
    loadingStatus () {
      return this.$store.state.loader.loadingStatus
    }
  }
}
</script>

<style scoped>
/* Custom Loader Styles */
.loader-content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.spinner-wrapper {
  position: relative;
  width: 150px;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.rotating-border {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 2px solid #5c3dd879;
  border-top-color: #5b3dd8;
  border-right-color: #5b3dd8;
  border-radius: 50%;
  animation: rotate-border 3s linear infinite;
}

.logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 120px;
  background: transparent;
  border-radius: 50%;
  box-shadow: none;
  z-index: 10;
}

.loader-logo {
  max-width: 100px;
  max-height: 100px;
  object-fit: contain;
}

@keyframes rotate-border {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
